import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Collapse, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import { get } from 'lodash'
import style from './style.css'
import { strVal } from '../../../../../../../modules/Utils'
import Compensation from '../Form/Compensation'
import WorkingConditions from '../Form/WorkingConditions'
import KeyTerms from '../Form/KeyTerms'
import Documents from '../../../../../../../components/Common/Documents/DocumentsCont'

import InfoText from '../../../../../../../elements/InfoText'
import Status from '../../../../../../../elements/Status'
import RefreshButton from '../../../../../../../elements/Buttons/RefreshButton'
import { withRouter } from 'react-router-dom'
import { streamUrl } from '../../../../../../../variables/index'
import IconText from '../../../../../../../elements/IconText'
import Authentication from '../../../../../../../modules/Authentication'

const { Panel } = Collapse
const { TabPane } = Tabs

class ViewWorkOrders extends Component {
  auth = new Authentication()

  render () {
    const {
      member,
      employee,
      fetching,
      workOrder,
      contract,
      id,
      contractKey,
      actions,
      handleOps,
      fetch,
      keyTermsCmpRef,
      payrollCmpRef,
      communicationCmpRef,
    } = this.props
    const Operations = ({ workOrder, ...rest }) => {
      const ops = actions.map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleOps(a.key, workOrder)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${workOrder._id}?access_token=${this.auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'}/>
        </a>,
      )
      return (
        <div {...rest}>
          {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
        </div>
      )
    }
    return (
      <Fragment>
        <Card loading={fetching}>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>People</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team">Team List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${id}/#contracts`}>{member.fn}</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${id}/contracts/${contractKey}/view#work-orders`}>
                {contract.code}
              </Breadcrumb.Item>
              <Breadcrumb.Item>{workOrder.code}</Breadcrumb.Item>
            </Breadcrumb>
            <h3 className={style.title}>
              <h3 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                <Tooltip title="Contract  Code">{strVal(workOrder, 'code')}</Tooltip>
                {' - ' + strVal(workOrder, 'title')}
              </h3>
              <Status value={strVal(workOrder, 'status')}/>
              <Operations style={{ marginTop: '10px' }} workOrder={workOrder} status={strVal(workOrder, 'status')}/>
              <RefreshButton onClick={fetch}/>
            </h3>
            <p className={style.paragraph}>{member.fn} Contract Details</p>
          </Row>
        </Card>
        <Row style={{ paddingTop: '10px' }}>
          <Card loading={fetching} style={{ minHeight: '542px' }}>
            <Row style={{ paddingTop: '10px' }}>
              <Tabs
                defaultActiveKey={get(this.props, 'location.hash') || '#dashboard'}
                onChange={(key) => this.props.history.push(key)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle"/>
                      Details
                    </span>
                  }
                  key="#dashboard">
                  <InfoText text={'To Update Contract Details please click on Update Button above.'}/>
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    <Panel header={<h3>Key Terms</h3>} key="1">
                      <KeyTerms
                        employee={employee}
                        ref={keyTermsCmpRef}
                        workOrder={workOrder}
                        updateContract={() => console.log('Not Implemented')}
                        type={'view'}
                      />
                    </Panel>
                    <Panel header={<h3>Working Conditions</h3>} key="5">
                      <WorkingConditions
                        employee={employee}
                        ref={payrollCmpRef}
                        workOrder={workOrder}
                        loading={fetching}
                        type={'view'}
                      />
                    </Panel>
                    <Panel header={<h3>Compensation</h3>} key="6">
                      <Compensation employee={employee} ref={communicationCmpRef} workOrder={workOrder} type={'view'}/>
                    </Panel>
                  </Collapse>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open"/>
                      Documents
                    </span>
                  }
                  key="#docs">
                  <Documents owner={workOrder}/>
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </Fragment>
    )
  }
}

export default withRouter(ViewWorkOrders)
